import React, { useEffect, useState, Fragment, useRef } from "react";
import { EmployeeTaskDetailReportTableContent } from '../../../Common/Table/tableContent';
import tokenService from '../../../../Common/tokenDecoder';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.data;
        const employeCount = this.props.employeCount;
        const contentRowNames = this.props.rowNames;
        const keys = this.props.keys;

        return (
            <div>
                <h3><center><u>Employee Task Detail Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.estate}</div>
                    <div className="col"><b>Category: </b> {searchData.category == undefined ? "All Categories" : searchData.category}</div>
                    <div className="col"><b>Task: </b> {searchData.task == undefined ? "All Tasks" : searchData.task}</div>
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                    <div className="col"><b>Registration Number: </b> {searchData.registrationNumber}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>
                <div className="card shadow-none bg-light">
                    <div className="row alternative_cls bg-light  ">
                        <div className="card-body width1"><p><b><p />Emp Name: </b>{data[0].firstName}</p> </div>
                        <div className="card-body width2"><p><b><p />Emp Type: </b>{data[0].employeeTypeName} </p> </div>
                        <div className="card-body width3"><p><b><p />Reg No: </b>{data[0].registrationNumber}</p> </div>
                        <div className="card-body width3"> <p><b><p />NOD: </b>{employeCount[0].employeCount}</p></div>

                    </div>
                    <div className="table-responsive row-top-gap">
                        <table className="display dataTable no-footer">
                            <thead>
                                <tr>
                                    <th>Collection Point</th>
                                    <th>Field</th>
                                    <th>Category</th>
                                    <th>Task</th>
                                    <th>Percentage (%)</th>
                                    <th>Date</th>
                                    <th>Start Time</th>
                                    <th>End Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                <EmployeeTaskDetailReportTableContent
                                    data={data}
                                    contentRowNames={contentRowNames}
                                    hasEdit={false}
                                />
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}